import { Form } from 'antd';
import React from 'react'
import StyledTextArea from '../../StyledTextArea';

const ObservationsInput = ({ value, onChange, initialValue }) => {
    return (
        <StyledTextArea
            initialaValue={initialValue}
            /* controlledValue={value} *///Update this value, to force text area to update
            onChange={(styled_text, plain_text) => {
                onChange(plain_text);
            }}
            options={[]}
            extraOptions={["speech-to-text"]}
        />
    )
}

export default ObservationsInput